// Sentry bootstrap for the admin console.
//
// The admin console is a signed-in B2B tool. Sentry (error + performance
// monitoring, no Session Replay) is treated as operationally essential and
// disclosed in the Cookie / Privacy policy shown at first login. It is
// therefore initialized unconditionally at app boot rather than gated on a
// per-user toggle — see `lib/consent.ts` for the reasoning. If we ever
// introduce optional non-essential telemetry, reintroduce a consent gate
// around it (Session Replay would be the obvious first case).

import * as Sentry from '@sentry/react';

let started = false;

const SENTRY_DSN = 'https://b2972dc780220f739a56013a93fde640@o4511683140714496.ingest.us.sentry.io/4511683219947520';

/** Idempotent — safe to call from `main.tsx` on every module evaluation. */
export const startClientSentry = (): void => {
  if (started) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 1.0,
  });
  started = true;
};
